import { useState, type FormEvent } from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useCreateCell } from "@/api/mutations/provisioning";

// #343 UC-1: Zelle registrieren. Das Einmal-Token kommt NUR in der Antwort — der Aufrufer zeigt es einmalig.
export function CreateCellDialog({ open, onOpenChange, onCreated }: { open: boolean; onOpenChange: (open: boolean) => void; onCreated: (cellName: string, enrollToken: string) => void }) {
  const [name, setName] = useState("");
  const [provider, setProvider] = useState("");
  const create = useCreateCell();

  function submit(e: FormEvent) {
    e.preventDefault();
    create.mutate(
      { name: name.trim(), provider: provider.trim() },
      {
        onSuccess: (cell) => {
          onOpenChange(false);
          onCreated(cell.name, cell.enrollToken);
        },
      },
    );
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="create-cell-dialog">
        <DialogHeader>
          <DialogTitle>Zelle anlegen</DialogTitle>
          <DialogDescription>Ein Kubernetes-Cluster mit Provisioner-Agent. Der Agent meldet sich mit dem Einmal-Token (7 Tage gueltig).</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="cell-name">Name (DNS-Label, = ELYVERS_CELL des Agenten)</Label>
            <Input id="cell-name" value={name} onChange={(e) => setName(e.target.value)} required placeholder="infomaniak-zrh1" data-testid="cell-name" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="cell-provider">Provider</Label>
            <Input id="cell-provider" value={provider} onChange={(e) => setProvider(e.target.value)} required placeholder="infomaniak" data-testid="cell-provider" />
          </div>
          {create.isError && <div className="text-sm text-danger" data-testid="create-cell-error">{create.error.message}</div>}
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} disabled={create.isPending}>Abbrechen</Button>
            <Button type="submit" disabled={create.isPending} data-testid="create-cell-submit">{create.isPending ? "…" : "Anlegen"}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
